import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import DeclinePage from './DeclinePage';
class DeclineSection extends Component {
  render() {
    const { bankId, brandId } = this.props;

    return <DeclinePage brandId={brandId} bankId={bankId} />;
  }
}

DeclineSection.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state)
});

export default connect(mapStateToProps)(DeclineSection);
